// extracted by mini-css-extract-plugin
export default {"containerFiltersHighlighted":"SearchResultWidget-module--container-filters-highlighted--4801d"};